import {
  CREATE_BACKGROUND_PLACEHOLDER,
  LOAD_BACKGROUND_PLACEHOLDERS_BY_BOOK_ID } from './../../action-types/entities/backgroundPlaceholders';

export const createBackgroundPlaceholders = backgroundPlaceholder => ({
  type: CREATE_BACKGROUND_PLACEHOLDER,
  backgroundPlaceholder,
});

export const loadBackgroundPlaceholderByBookId = bookState => ({
  type: LOAD_BACKGROUND_PLACEHOLDERS_BY_BOOK_ID,
  bookState,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/backgroundPlaceholders.js